import {
  LayoutDashboard,
  MapPin,
  Bookmark,
  Users,
  LogOut,
  MessageCircle,
  Blocks,
  X,
  Menu,
  HotelIcon,
  PlaneIcon
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../store/authStore";

export default function AdminSidebar({
  activeTab,
  setActiveTab,
  sidebarOpen,
  setSidebarOpen,
  children,
}) {
  const navigate = useNavigate();
  const { logout } = useAuthStore();

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const menuItems = [
    { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
    { id: "tours", label: "Manage Tours", icon: MapPin },
    { id: "bookings", label: "Bookings", icon: Bookmark },
    { id: "blogs", label: "Blogs", icon: Blocks },
    { id: "messages", label: "Messages", icon: MessageCircle },
    { id: "users", label: "Users", icon: Users },
      { id: "hotels", label: "Hotel Request", icon: HotelIcon },
       { id: "flights", label: "Flight Request", icon: PlaneIcon },
  ];

  const handleNavClick = (tab) => {
    setActiveTab(tab);
    if (window.innerWidth < 1024) setSidebarOpen(false);
  };

  return (
    <div className="flex min-h-screen bg-gray-100 dark:bg-slate-900">

      {/* MOBILE OVERLAY */}
      {sidebarOpen && (
        <div
          onClick={() => setSidebarOpen(false)}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-40 lg:hidden"
        />
      )}

      {/* SIDEBAR */}
      <aside
        className={`
          fixed lg:relative z-50 top-0 left-0 h-full w-64 
          bg-white dark:bg-slate-800 border-r border-gray-200 dark:border-slate-700
          shadow-lg flex flex-col
          transition-transform duration-300 ease-in-out
          ${sidebarOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}
        `}
      >
        {/* HEADER */}
        <div className="flex items-center justify-between px-6 py-5 border-b border-gray-200 dark:border-slate-700">
          <h2 className="text-xl font-bold text-gray-900 dark:text-white tracking-tight">
            Admin Panel
          </h2>
          <button
            onClick={() => setSidebarOpen(false)}
            className="lg:hidden text-gray-600 dark:text-gray-300"
          >
            <X size={22} />
          </button>
        </div>

        {/* NAVIGATION */}
        <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;

            return (
              <button
                key={item.id}
                onClick={() => handleNavClick(item.id)}
                className={`
                  flex items-center w-full gap-3 px-4 py-3 rounded-lg font-medium
                  transition-all duration-200
                  ${
                    isActive
                      ? "bg-gradient-to-r from-blue-500 to-indigo-600 text-white shadow-md scale-[1.01]"
                      : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700/40"
                  }
                `}
              >
                <Icon size={20} className={`${isActive ? "text-white" : "opacity-80"}`} />
                {item.label}
              </button>
            );
          })}
        </nav>

        {/* LOGOUT */}
        <div className="px-4 pb-6">
          <button
            onClick={handleLogout}
            className="flex items-center w-full gap-3 px-4 py-3 rounded-lg
              text-red-600 dark:text-red-400 font-medium
              hover:bg-red-100 dark:hover:bg-red-900/30 transition-all duration-200"
          >
            <LogOut size={20} />
            Logout
          </button>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <main className="flex-1 ">
        {/* MOBILE MENU BUTTON */}
       

        {/* CHILD CONTENT */}
        <div>{children}</div>
      </main>
    </div>
  );
}
